import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PosIp800ModalModule } from '../pos-ip800-modal/pos-ip800-modal.module';
import { PosPrintDocumentsModalComponent } from './pos-print-documents-modal.component';



@NgModule({
  declarations: [PosPrintDocumentsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    UiSwitchModule,
    ToastrModule.forRoot(),
    PosIp800ModalModule
  ],
  exports: [PosPrintDocumentsModalComponent]
})
export class PosPrintDocumentsModalModule { }
